import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Grid2 } from '@mui/material';

import { GeneralForm } from './components';
import { SetFormState, GetOperators } from '../../../../actions/SettingsActions';

const useStyles = makeStyles(() => ({
	root: {},
}));

const General = (props) => {
	const { className, ...rest } = props;

	const classes = useStyles();
	const dispatch = useDispatch();
	const user = useSelector(state => state.session.user);
	const formState = useSelector((state) => state.settingsReducer.formState);
	useEffect(() => {
		let mounted = true;

		dispatch(SetFormState({
			...formState,
			values: { ...user }
		}));

		if (user && user.id) {
			dispatch(GetOperators(user.id));
		}

		return () => {
			mounted = false;
		};
	}, []);

	if (!user) {
		return null;
	}

	return (
		<Grid2
			{...rest}
			className={clsx(classes.root, className)}
			container
			spacing={3}
		>
			<Grid2 item size={12}>
				<GeneralForm role={user.role} />
			</Grid2>
		</Grid2>
	);
};

General.propTypes = {
	className: PropTypes.string,
};

export default General;
